// components/Hero.jsx
import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-light to-blue-50 pt-16">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        <motion.div 
          className="md:w-1/2 text-center md:text-left mb-10 md:mb-0"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            <span className="block">Hi, I'm</span>
            <span className="text-primary block">Dulani Kariyawasam</span>
          </h1>
          <h2 className="text-xl md:text-2xl mb-6 text-gray-600">Software Engineering Undergraduate</h2>
          <p className="text-lg mb-8 max-w-lg">
            Passionate about building innovative solutions and transforming ideas into reality through code.
          </p>
          <div className="flex space-x-4 justify-center md:justify-start">
            <a 
              href="https://github.com/dula089" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-dark text-white p-3 rounded-full hover:bg-primary transition-colors"
            >
              <FaGithub size={24} />
            </a>
            <a 
              href="https://www.linkedin.com/in/dulani-kariyawasam-48a86b294" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-dark text-white p-3 rounded-full hover:bg-primary transition-colors"
            >
              <FaLinkedin size={24} />
            </a>
            <a 
              href="mailto:hansamalidulani6678@gmail.com" 
              className="bg-dark text-white p-3 rounded-full hover:bg-primary transition-colors"
            >
              <HiMail size={24} />
            </a>
          </div>
          <div className="mt-8">
            <a 
              href="#contact" 
              className="bg-primary text-white px-8 py-3 rounded-md hover:bg-opacity-90 transition-all shadow-md"
            >
              Contact Me
            </a>
          </div>
        </motion.div>
        
        <motion.div 
          className="md:w-1/2"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="bg-primary bg-opacity-10 p-8 rounded-xl border-2 border-primary border-opacity-20 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-primary">Software Engineering Student</h3>
            <p className="mb-4">University of Westminster (IIT SL)</p>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="text-4xl font-bold text-primary">3.5+</p>
                <p className="text-sm">Current GPA</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="text-4xl font-bold text-primary">5+</p>
                <p className="text-sm">Projects</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="text-4xl font-bold text-primary">6+</p>
                <p className="text-sm">Certificates</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="text-4xl font-bold text-primary">2+</p>
                <p className="text-sm">Competitions</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;